import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-730c0f88"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex gap-[8px] h-[32px] items-center flex-nowrap" }
const _hoisted_2 = { class: "text-[12px] font-gordita-regular whitespace-nowrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " Status: ", -1))
const _hoisted_4 = { class: "font-gordita-medium agent-sort-by--sorting-field" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil icon-down-small !text-[10px] ml-[10px] !mr-0" }, null, -1))

import { IncrediButton, IncrediItem, IncrediList, IncrediMenu } from 'incredi-ui';
import { computed, inject, ref } from 'vue';
import { User_Status } from '@/graphql/codegen/generated/graphql';
import { IKRightDrawer } from '@/views/Layout/RightDrawer.InjectionKeys';
import { useUsersPage } from '../users.helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'usersActivityFilter',
  setup(__props) {

const usersPage = useUsersPage();
const menu = ref(false);
const returnAll = 'All';
const rightDrawer = inject(IKRightDrawer);

const statuses = computed(
  () =>
    [returnAll, User_Status.Active, User_Status.Inactive, usersPage?.usersTable.usersGql.result.value?.users?.some(user => user?.status === User_Status.Locked) ? User_Status.Locked : null].filter(
      Boolean,
    ) as (User_Status | 'All')[],
);

const currFilter = computed(() => usersPage?.usersTable.filters.status.get.value || returnAll);
const quickFilterState = (status: User_Status | 'All') => status === currFilter.value;

const updateQuickFilter = (status: User_Status | 'All') => {
  usersPage?.usersTable.filters.status.set(status);
  usersPage?.usersTable.selectedUser.clear();
  rightDrawer?.close();
  menu.value = false;
};

return (_ctx: any,_cache: any) => {
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_unref(IncrediMenu), {
    modelValue: menu.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((menu).value = $event)),
    direction: 'bottom-sticky-right',
    "offset-y": 4,
    "fill-width": ""
  }, {
    content: _withCtx(() => [
      _createVNode(_unref(IncrediList), null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(statuses), (status, index) => {
            return _withDirectives((_openBlock(), _createBlock(_unref(IncrediItem), {
              key: index,
              dense: "",
              clickable: "",
              class: _normalizeClass(["users-table-quick-filter-item", { 'users-table-quick-filter-item-selected ibf-gordita-12-m': quickFilterState(status as User_Status| 'All') }]),
              onClick: ($event: any) => (updateQuickFilter(status as User_Status | 'All'))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(status), 1)
              ]),
              _: 2
            }, 1032, ["class", "onClick"])), [
              [_directive_close_popup]
            ])
          }), 128))
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(IncrediButton), {
        "data-testid": "user-status-filter",
        selected: menu.value,
        design: "master",
        class: "flex",
        size: "small"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(User_Status)[_unref(currFilter) as 'Active' | 'Inactive' | 'Locked'] || 'All'), 1),
              _hoisted_5
            ])
          ])
        ]),
        _: 1
      }, 8, ["selected"])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})